import { Component, OnInit, ViewChild } from '@angular/core';
import { NgForm } from '@angular/forms';
import { ConfirmationService, Message } from 'primeng/api';
import { Empresa } from 'src/app/admihair/api/dto/empresa';
import { Fornecedor } from 'src/app/admihair/api/dto/fornecedor';
import { PagamentoDespesa } from 'src/app/admihair/api/dto/pagamento-despesa';
import { PlanoContaEmpresa } from 'src/app/admihair/api/dto/plano-conta-empresa.';
import { TipoPagamento } from 'src/app/admihair/api/dto/tipo-pagamento';
import { ErroService } from 'src/app/admihair/service/erro.service';
import { FornecedorService } from 'src/app/admihair/service/fornecedor.service';
import { PagamentoDespesaService } from 'src/app/admihair/service/pagamento-despesa.service';
import { PlanoContaEmpresaService } from 'src/app/admihair/service/plano-conta-empresa.service';
import { TipoPagamentoService } from 'src/app/admihair/service/tipo-pagamento.service';
import { UtilStorageService } from 'src/app/admihair/service/util-storage.service';
import { AuthUtil } from 'src/app/admihair/util/auth-util';

@Component({
  selector: 'app-pagamento-despesa-inserir',
  templateUrl: './pagamento-despesa-inserir.component.html',
  styleUrls: ['./pagamento-despesa-inserir.component.scss']
})
export class PagamentoDespesaInserirComponent implements OnInit {

  permissaoInserir: boolean = false;
  messages: Message[] = [];
  messagemVisivel: boolean = false;
  progressoRequisicao: boolean = false;
  empresaSelecionada?: Empresa;
  planosContaEmpresa: PlanoContaEmpresa[] = [];
  parcelaInicial: number = 1;
  fornecedores: Fornecedor[] = [];
  contaSelecionada?: PlanoContaEmpresa;
  tiposPagamento: TipoPagamento[] = [];
  dataAtual: Date = new Date();
  agendamentoPagamento: boolean = false;
  @ViewChild('f') form?: NgForm;
  value?: string;


  constructor(
    private pagamentoDespesaService: PagamentoDespesaService,
    private planoContaEmpresaService: PlanoContaEmpresaService,
    private fornecedorService: FornecedorService,
    private tipoPagamentoService: TipoPagamentoService,
    private utilStorageService: UtilStorageService,
    private confirmationService: ConfirmationService,
    private erroService: ErroService) { }


  ngOnInit(): void {
    this.permissaoInserir = this.verificarPermissao('PERM_INSERIR_PAGAMENTO_DESPESA');
    this.empresaSelecionada = this.utilStorageService.getEmpresa();
    if (this.permissaoInserir) {
      this.buscarContas();
      this.buscarFornecedores();
      this.carregarTiposPagamento();
    }
  }

  salvar() {
    this.progressoRequisicao = true;
    const pagamentoDespesa: PagamentoDespesa = this.form?.value;
    pagamentoDespesa.empresaId = this.empresaSelecionada?.id
    if (this.agendamentoPagamento) {
      pagamentoDespesa.status = 2;
    } else {
      pagamentoDespesa.status = 1;
    }
    pagamentoDespesa.profissionalId = 0;
    pagamentoDespesa.operador = this.utilStorageService.getUser().usuario.id;

    this.pagamentoDespesaService.salvar(pagamentoDespesa).subscribe({
      next: (data: PagamentoDespesa[]) => {
        this.messages = this.erroService.handleSuccess();
        this.messagemVisivel = true;
        this.progressoRequisicao = false;
        this.rolarTela()
        this.limparFormulario();
        this.agendamentoPagamento = false;
      },
      error: (err: any) => {
        this.progressoRequisicao = false;
        this.messages = this.erroService.handleErro(err);
        this.messagemVisivel = true;
        this.rolarTela();
      }
    })

  }

  buscarFornecedores() {
    this.fornecedorService.listarPorEmpresaId(this.empresaSelecionada?.id).subscribe({
      next: (data: Fornecedor[]) => {
        this.fornecedores = data;
      },
      error: (err: any) => {
        this.messages = this.erroService.handleErro(err);
        this.messagemVisivel = true;
      }
    })
  }

  carregarTiposPagamento() {
    this.tipoPagamentoService.listarPorEmpresaEOperacaoDespesa(this.empresaSelecionada?.id)
      .subscribe({
        next: (data: TipoPagamento[]) => {
          this.tiposPagamento = data;
        },
        error: (err: any) => {
          this.messages = this.erroService.handleErro(err);
          this.messagemVisivel = true;
        }
      })
  }

  buscarContas() {
    const utilizacoes: string[] = ['DESPESA', 'FOLHA/DESPESA'];
    this.planoContaEmpresaService.listarPorEmpresaEUtilizacao(this.empresaSelecionada?.id, utilizacoes)
      .subscribe({
        next: (data: PlanoContaEmpresa[]) => {
          this.planosContaEmpresa = data;
        },
        error: (err: any) => {
          this.messages = this.erroService.handleErro(err);
          this.messagemVisivel = true;
        }
      })
  }

  selecionarData(dataSelecionada?: Date) {
    if (dataSelecionada && dataSelecionada > this.dataAtual) {
      this.confirmationService.confirm({
        message: 'Data maior que o dia atual. Deseja agendar o pagamento?',
        header: 'Confirmação',
        acceptLabel: 'Sim',
        rejectLabel: 'Não',
        icon: 'pi pi-info-circle',
        accept: () => {
          this.agendamentoPagamento = true;
        }
      });
    } else {
      this.agendamentoPagamento = false;
    }
  }

  verificarValorParcela(valor: any) {
    return valor > 0;
  }

  verificarPermissao(nome: string): boolean {
    return AuthUtil.verificarPermissao(nome);
  }

  rolarTela() {
    window.scroll({
      top: 0,
      left: 0,
      behavior: 'smooth'
    });
  }

  limparFormulario() {
    this.form?.reset();
  }

  ocultarMensagem() {
    if (this.messagemVisivel) {
      this.messagemVisivel = false;
    }
  }
}
